module.exports = __webpack_public_path__ + "img/C8AF84_F9ECD7_EFDEBF_E6D1AF-256px.ac9c1088.png";